module.exports = "query GetOrder($id: ID!) {\n  order(id: $id) {\n    ...DetailedOrderFragment\n  }\n}\n"